<div class="sidebar-item-display-toggle">
    <button
        class="sidebar-item-display-toggle__button"
        [class.sidebar-item-display-toggle__button--active]="display"
        (click)="setListActive()"
    >
        <ui-icon
            aria-hidden
            class="sidebar-item-display-toggle__icon"
            [icon]="'sidebar-mode-list'"
        />
        <span>Listenansicht</span>
    </button>
    <button
        class="sidebar-item-display-toggle__button"
        [class.sidebar-item-display-toggle__button--active]="!display"
        (click)="setGridActive()"
    >
        <ui-icon
            aria-hidden
            class="sidebar-item-display-toggle__icon"
            [icon]="'sidebar-mode-tile'"
        />
        <span>Rasteransicht</span>
    </button>
</div>
